<template>
  <div class="wrapper">
    <section class="answer-one answer">
      <div class="container answer__container">
        <div class="answer__block--title four--block-answer">
          <span class="levels__love-bg">
            <picture>
              <source srcset="~@/assets/img/level-love-4.avif" type="image/avif">
              <source srcset="~@/assets/img/level-love-4.webp" type="image/webp">
              <img loading="lazy" src="~@/assets/img/level-love-4.png" class="image" width="54" height="166" alt="Love">
            </picture>
          </span>
          <h2 class="answer__title">Уровень 4</h2>
          <p class="answer__subtitle">Средний:</p>
        </div>
        <div class="answer__content">
          <div class="process-bar__label">Потенциал любовной энергии</div>
          <div class="process-bar">
            <div class="process-bar__line result-4"></div>
            <div class="process-bar__value">95%</div>
          </div>
          <div class="process-bar-listing">
            <div class="process-bar-listing__title">Любовная энергия на данный момент:</div>
            <div class="process-bar-list__label">Любовь к себе</div>
            <div class="process-bar-list">
              <div class="process-bar-list__line result-4_list_1"></div>
              <div class="process-bar-list__value">28%</div>
            </div>
            <div class="process-bar-list__label">Любовь к окружающим </div>
            <div class="process-bar-list">
              <div class="process-bar-list__line result-4_list_2"></div>
              <div class="process-bar-list__value">35%</div>
            </div>
            <div class="process-bar-list__label">Любовь к жизни</div>
            <div class="process-bar-list">
              <div class="process-bar-list__line result-4_list_3"></div>
              <div class="process-bar-list__value">41%</div>
            </div>
          </div>
          <div class="text-icon">
            <img src="@/assets/img/svg/icon_1_text.svg" />
            <p>У вас большой потенциал любовной энергии и есть все задатки, чтобы любить
              и быть любимой! Это значит, что <span>вы готовы дарить
              и принимать любовь
              и знаете, как работать над отношениями</span> для их укрепления и благополучия. </p>
          </div>
          <p class="answer__content--text">Более того, у вас есть все шансы
            на создание счастливого и прочного союза с любимым человеком. Однако по вашим ответам видно, что на данный момент уровень вашей энергии любви средний. <span>Вам
            не хватает опоры в себе
            и уверенности в собственной значимости.</span> Вам трудно понять, чего вы на самом деле хотите,
            вы склонны поддаваться переменчивым настроениям
            и впадать в крайности. Вы можете вступать в отношения, только чтобы быть с кем-то, потому что
            боитесь настоящей близости
            и не разрешаете себе довериться даже хорошему человеку. При этом вам попадаются достойные мужчины, которых вы <span>не можете “разглядеть”</span> и сразу отказываетесь от них.
          </p>
          <div class="text-icon icon-top m28">
            <img src="@/assets/img/svg/icon_2_text.svg" />
            <p>Если не работать над повышением уровня своей любовной энергии, можно так никогда и не встретить настоящей любви. </p>
          </div>
          <p class="answer__content--text no-margin">Потому что страх перед доверительными отношениями
            <span>не позволит вам открыться</span>
            по-настоящему достойному партнеру и обрести с ним счастье. Чтобы его побороть и предотвратить такие последствия, вам необходимо поднимать свой уровень до высокого.
          </p>
          <p class="answer__content--text m28">Вам необходимо поверить в себя и в собственные силы, не соглашаться на все, что вам предлагают, а самой делать выбор. Только так вы сможете поднять свой уровень энергии любви. </p>
          <div class="block-text">
            <div class="block-text__title">Высокий уровень любви даст вам:</div>
            <div class="block-text__text">— здоровую самооценку;
            </div>
            <div class="block-text__text">
              — умение любить себя такой, какая вы есть;
            </div>
            <div class="block-text__text">
              — способность быть любимой;
            </div>
            <div class="block-text__text">
              — счастливые отношения;
            </div>
            <div class="block-text__text">
              — внутреннее равновесие;
            </div>
            <div class="block-text__text">
              — избавление от одиночества.
            </div>
          </div>

          <div class="rs-title">Персональные рекомендации для вас:</div>
          <div class="rs-block">
            <div class="rs-block__table">
              <div class="rs-block__number">01</div>
              <div class="rs-block__subtitle">Аффирмации на развитие доверия. </div>
            </div>
            <div class="rs-block__text">Ежедневно повторяйте утвердительные фразы перед зеркалом: “Я доверяю себе. Я доверяю людям. Я доверяю жизни. Я доверяю миру. Вселенная знает, что для меня лучше. Она посылает мне удачу, позитивные события и прекрасные возможности. Я принимаю ее дары и верю в ее справедливость”.</div>
          </div>
          <div class="rs-block">
            <div class="rs-block__table">
              <div class="rs-block__number">02</div>
              <div class="rs-block__subtitle icon_number"> Амулет
                <br />“Энергия любви”.</div>
            </div>
            <div class="rs-block__text icon_end">Каждый браслет я настраиваю под энергетику будущего владельца <br>путем индивидуального заряда. <br>Поэтому он будет работать с <br>вашими персональными задачами и решать ваши личные проблемы. <br>Амулет настроит вас на любовь к <br>себе, через которую уйдут страхи и неуверенность — в себе и в <br>партнере. Он поможет понять вам <br>свои настоящие желания и <br>истинные потребности. <br>Как работает амулет и чем он вам поможет — читайте тут</div>
            <div class="more">
              <a class="info__button btn_rs btn" :href="url" onclick="ym(56736205,'reachGoal','amuletslovetest')">Заказать амулет</a>
            </div>
          </div>
          <div class="rs-block">
            <div class="rs-block__table">
              <div class="rs-block__number">03</div>
              <div class="rs-block__subtitle">Практика для обретения уверенности в отношениях.</div>
            </div>
            <div class="rs-block__text">Ее желательно выполнять вместе с партнером, но если нет такой возможности, можно практиковаться одной. В первом случае необходимо встать к партнеру спиной на расстоянии полуметра и медленно падать назад — чтобы он вас поймал. Во втором случае проделывайте то же самое со стеной, отчетливо представляя партнера. Опускайтесь назад и упирайтесь в стену. С помощью этой техники вы развиваете уверенность в том, что любимый человек вас не бросит, а поддержит.</div>
          </div>
        </div>
      </div>
    </section>
    <FooterResult />
  </div>
</template>

<script>
import FooterResult from "@/components/FooterResult";
export default {
  name: "Result4",
  components: {FooterResult},
  computed: {
    utm() {
      return this.$store.getters['utm']
    },
    url() {
      let link = 'https://store.taroirena.ru/shop/amulety/braslet-energiya-lyubvi/'
      if(this.utm.utm_source) {
        link += '?utm_source=' + this.utm.utm_source
      }
      if(this.utm.utm_medium) {
        link += '&utm_medium=' + this.utm.utm_medium
      }
      if(this.utm.utm_campaign) {
        link += '&utm_campaign=' + this.utm.utm_campaign
      }
      if(this.utm.utm_content) {
        link += '&utm_content=' + this.utm.utm_content
      }
      if(this.utm.utm_term) {
        link += '&utm_term=' + this.utm.utm_term
      }
      return link
    }
  }
}
</script>